import styled from 'styled-components';

const ItemError = styled.div`
  padding-left: ${(props): string => props.theme.spaces.lg};
  padding-right: ${(props): string => props.theme.spaces.lg};
`;

export { ItemError };
